module.exports = __webpack_public_path__ + "img/10 to end of month-cashflow-after-change.fa759ad9.svg";